export default __webpack_public_path__ + "static/media/vitural.5f5e00e2.png";